import script from "./IOrderMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./IOrderMenu.vue?vue&type=script&setup=true&lang=ts"

import "./IOrderMenu.vue?vue&type=style&index=0&id=f694f59a&lang=scss"

const __exports__ = script;

export default __exports__